import {
  FaFacebookF,
  FaLinkedinIn,
  FaInstagram,
  FaTwitter,
  FaYoutube,
} from "react-icons/fa";

import {
  HiOutlineLocationMarker,
  HiOutlinePhone,
  HiOutlineMail,
  HiOutlineGlobeAlt,
  HiOutlineArrowRight,
} from "react-icons/hi";

import { useState } from "react";
import { Link } from "react-router-dom";

const Footer = ({ darkMode }) => {
  const [email, setEmail] = useState("");

  const handleSubscribe = (e) => {
    e.preventDefault();
    alert(`Subscribed with: ${email}`);
    setEmail("");
  };

  // const textColor = darkMode ? "text-white" : "text-gray-900";

  const footerBg = darkMode
    ? "bg-gray-950"
    : "bg-slate-50";

  const borderColor = darkMode
    ? "border-gray-800"
    : "border-gray-200";

  const mutedText = darkMode
    ? "text-gray-400"
    : "text-gray-600";

  const socialLinks = [
    {
      icon: FaFacebookF,
      href: "https://www.facebook.com/people/Innovative-Academy-For-It-Solutions/61567177282782/",
      label: "Facebook",
      bg: "from-blue-600 to-indigo-500",
    },
    {
      icon: FaLinkedinIn,
      href: "https://www.linkedin.com/company/ia4solutions/",
      label: "LinkedIn",
      bg: "from-blue-500 to-cyan-500",
    },
    {
      icon: FaInstagram,
      href: "https://www.instagram.com/innovativeacademyitsolutions/",
      label: "Instagram",
      bg: "from-pink-500 to-orange-400",
    },
    {
      icon: FaTwitter,
      href: "https://x.com/ia4solution",
      label: "X / Twitter",
      bg: "from-gray-700 to-black",
    },
    {
      icon: FaYoutube,
      href: "https://www.youtube.com/@ia4solutions",
      label: "YouTube",
      bg: "from-red-500 to-pink-600",
    },
  ];

  const quickLinks = [
    { name: "Home", path: "/" },
    { name: "About", path: "/about" },
    { name: "Courses", path: "/courses" },
    { name: "Services", path: "/services" },
    { name: "Placements", path: "/placements" },
    { name: "Contact", path: "/contact" },
  ];

  const recognitionLogos = [
    {
      name: "MSME",
      image: "/images/accreditations/msme.png",
    },
    {
      name: "AICTE",
      image: "/images/accreditations/aicte.png",
    },
    {
      name: "APSCHE",
      image: "/images/accreditations/apsche.png",
    },
  ];

  return (
    <footer
      className={`relative ${footerBg} border-t ${borderColor} overflow-hidden`}
    >
      {/* Decorative Background */}
      <div
        className={`absolute inset-0 pointer-events-none ${
          darkMode
            ? "bg-[radial-gradient(circle_at_10%_10%,rgba(249,115,22,0.08),transparent_30%),radial-gradient(circle_at_90%_20%,rgba(59,130,246,0.08),transparent_30%)]"
            : "bg-[radial-gradient(circle_at_10%_10%,rgba(249,115,22,0.05),transparent_30%),radial-gradient(circle_at_90%_20%,rgba(59,130,246,0.05),transparent_30%)]"
        }`}
      />

      <div className="relative">

        {/* ========================================================= */}
        {/* MAIN FOOTER */}
        {/* ========================================================= */}

        <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-12 lg:py-14">

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-12">

            {/* ===================================================== */}
            {/* BRAND */}
            {/* ===================================================== */}

            <div className="lg:col-span-1">
              <Link
                to="/"
                className="inline-flex items-center gap-3 group"
              >
                <img
                  src="/images/logos/ia4s_logo.jpeg"
                  alt="IA4Solutions Logo"
                  className="w-12 h-12 object-cover rounded-full border-2 border-orange-400 shadow-md transition-transform duration-300 group-hover:scale-105"
                />

                <span className="text-xl sm:text-2xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-orange-400 to-pink-500">
                  ia4solutions
                </span>
              </Link>

              <p
                className={`${mutedText} text-sm leading-7 mt-5 max-w-sm`}
              >
                Innovate | Learn | Succeed.
                <br />
                Bridging the gap between learning and career success.
              </p>

              {/* Social Icons */}
              <div className="flex flex-wrap gap-3 mt-6">
                {socialLinks.map((social) => {
                  const Icon = social.icon;

                  return (
                    <a
                      key={social.label}
                      href={social.href}
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label={`IA4Solutions ${social.label}`}
                      title={social.label}
                      className={`w-10 h-10 rounded-full bg-gradient-to-tr ${social.bg} flex items-center justify-center shadow-md hover:scale-110 hover:-translate-y-0.5 transition-all duration-300`}
                    >
                      <Icon className="text-white w-4 h-4" />
                    </a>
                  );
                })}
              </div>
            </div>

            {/* ===================================================== */}
            {/* CONTACT */}
            {/* ===================================================== */}

            <div>
              <h3
                className={`text-lg font-bold mb-5 ${
                  darkMode ? "text-white" : "text-gray-900"
                }`}
              >
                Contact Us
              </h3>

              <div className="space-y-4">

                {/* Address */}
                <div className="flex items-start gap-3">
                  <div className="flex-shrink-0 mt-0.5">
                    <HiOutlineLocationMarker className="w-5 h-5 text-orange-500" />
                  </div>

                  <p
                    className={`${mutedText} text-sm leading-6`}
                  >
                    #23-7-168, Santhi Nagar,
                    <br />
                    M.R.Palli Circle,
                    <br />
                    Tirupati – 517502
                  </p>
                </div>

                {/* Phone */}
                <div className="flex items-center gap-3">
                  <HiOutlinePhone className="w-5 h-5 text-orange-500 flex-shrink-0" />

                  <a
                    href="tel:+918332029863"
                    className={`${mutedText} text-sm hover:text-orange-500 transition-colors`}
                  >
                    8332029863 | 8008638374
                  </a>
                </div>

                {/* Email */}
                <div className="flex items-center gap-3">
                  <HiOutlineMail className="w-5 h-5 text-orange-500 flex-shrink-0" />

                  <a
                    href="mailto:hr@ia4solutions.com"
                    className={`${mutedText} text-sm hover:text-orange-500 transition-colors break-all`}
                  >
                    hr@ia4solutions.com
                  </a>
                </div>

                {/* Website */}
                <div className="flex items-center gap-3">
                  <HiOutlineGlobeAlt className="w-5 h-5 text-orange-500 flex-shrink-0" />

                  <a
                    href="https://www.ia4solutions.com"
                    target="_blank"
                    rel="noopener noreferrer"
                    className={`${mutedText} text-sm hover:text-orange-500 transition-colors`}
                  >
                    www.ia4solutions.com
                  </a>
                </div>

              </div>
            </div>

            {/* ===================================================== */}
            {/* NEWSLETTER */}
            {/* ===================================================== */}

            <div>
              <h3
                className={`text-lg font-bold mb-5 ${
                  darkMode ? "text-white" : "text-gray-900"
                }`}
              >
                Stay Connected
              </h3>

              <p
                className={`${mutedText} text-sm leading-6 mb-5`}
              >
                Get updates on courses, workshops, career opportunities, and
                upcoming events.
              </p>

              <form
                onSubmit={handleSubscribe}
                className="space-y-3"
              >
                <input
                  type="email"
                  placeholder="Enter your email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  aria-label="Email address"
                  required
                  className={`w-full px-4 py-3 rounded-xl border outline-none transition-all duration-200 ${
                    darkMode
                      ? "bg-gray-900 border-gray-700 text-white placeholder-gray-500 focus:border-orange-500"
                      : "bg-white border-gray-300 text-gray-900 placeholder-gray-500 focus:border-orange-500"
                  }`}
                />

                <button
                  type="submit"
                  className="w-full flex items-center justify-center gap-2 px-5 py-3 rounded-xl font-semibold text-white bg-gradient-to-r from-orange-500 to-yellow-400 hover:from-yellow-400 hover:to-orange-500 shadow-md hover:shadow-lg transition-all duration-300"
                >
                  Subscribe
                  <HiOutlineArrowRight className="w-4 h-4" />
                </button>
              </form>
            </div>

            {/* ===================================================== */}
            {/* QUICK LINKS */}
            {/* ===================================================== */}

            <div>
              <h3
                className={`text-lg font-bold mb-5 ${
                  darkMode ? "text-white" : "text-gray-900"
                }`}
              >
                Quick Links
              </h3>

              <ul className="space-y-3">
                {quickLinks.map((link) => (
                  <li key={link.name}>
                    <Link
                      to={link.path}
                      className={`${mutedText} text-sm inline-flex items-center gap-2 hover:text-orange-500 hover:translate-x-1 transition-all duration-200`}
                    >
                      <span className="text-orange-500">›</span>
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

          </div>
        </div>

        {/* ========================================================= */}
        {/* REGISTRATIONS & RECOGNITIONS */}
        {/* ========================================================= */}

        <div
          className={`border-y ${borderColor} ${
            darkMode ? "bg-gray-900/70" : "bg-white/70"
          }`}
        >
          <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-8">

            <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-7">

              {/* Section Heading */}
              <div className="text-center md:text-left md:min-w-[270px]">
                <p
                  className="text-xs font-semibold uppercase tracking-[0.18em] text-orange-500 mb-2"
                >
                  Trust & Credibility
                </p>

                <h3
                  className={`text-xl sm:text-2xl font-bold ${
                    darkMode ? "text-white" : "text-gray-900"
                  }`}
                >
                  Registrations & Recognitions
                </h3>

                <p
                  className={`${mutedText} text-xs sm:text-sm mt-2`}
                >
                  Our institutional associations and registrations
                </p>
              </div>

              {/* Logos */}
              <div className="flex-1">
                <div className="flex flex-wrap items-center justify-center md:justify-end gap-4 sm:gap-5">

                  {recognitionLogos.map((item) => (
                    <div
                      key={item.name}
                      className={`group w-[150px] sm:w-[170px] h-[92px] sm:h-[102px] rounded-2xl border ${
                        darkMode
                          ? "bg-white border-gray-200"
                          : "bg-white border-gray-200"
                      } shadow-sm hover:shadow-lg hover:-translate-y-1 transition-all duration-300 flex items-center justify-center px-5 py-4`}
                    >
                      <img
                        src={item.image}
                        alt={`${item.name} logo`}
                        className="max-w-full max-h-[62px] sm:max-h-[70px] object-contain transition-transform duration-300 group-hover:scale-105"
                        loading="lazy"
                      />
                    </div>
                  ))}

                </div>
              </div>

            </div>
          </div>
        </div>

        {/* ========================================================= */}
        {/* BOTTOM BAR */}
        {/* ========================================================= */}

        <div
          className={`border-t ${borderColor}`}
        >
          <div className="container mx-auto px-4 sm:px-6 lg:px-8">

            <div className="flex flex-col sm:flex-row items-center justify-between gap-3 py-5">

              <p
                className={`${mutedText} text-xs sm:text-sm text-center sm:text-left`}
              >
                &copy; {new Date().getFullYear()} IA4Solutions. All rights reserved.
              </p>

              <div className="flex items-center gap-5">
                <Link
                  to="/privacy-policy"
                  className={`${mutedText} text-xs sm:text-sm hover:text-orange-500 transition-colors`}
                >
                  Privacy Policy
                </Link>

                <Link
                  to="/terms"
                  className={`${mutedText} text-xs sm:text-sm hover:text-orange-500 transition-colors`}
                >
                  Terms & Conditions
                </Link>
              </div>

            </div>
          </div>
        </div>

      </div>
    </footer>
  );
};

export default Footer;